module.exports = __webpack_public_path__ + "img/symbol_2.7fb30587.png";